// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertyGroupIdBuf } from '../entity/entity-property-group-id-buf.js';
import { UuidBuf } from '../entity/uuid-buf.js';


/**
 * This is a specific set of property ranges for a given property group id.
 */
export class EntityPropertySelectionEntryBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EntityPropertySelectionEntryBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEntityPropertySelectionEntryBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertySelectionEntryBuf):EntityPropertySelectionEntryBuf {
  return (obj || new EntityPropertySelectionEntryBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEntityPropertySelectionEntryBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertySelectionEntryBuf):EntityPropertySelectionEntryBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EntityPropertySelectionEntryBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

groupId():EntityPropertyGroupIdBuf {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : EntityPropertyGroupIdBuf._Unused;
}

starts(index: number, obj?:UuidBuf):UuidBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new UuidBuf()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

startsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

ends(index: number, obj?:UuidBuf):UuidBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new UuidBuf()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

endsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startEntityPropertySelectionEntryBuf(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addGroupId(builder:flatbuffers.Builder, groupId:EntityPropertyGroupIdBuf) {
  builder.addFieldInt32(0, groupId, EntityPropertyGroupIdBuf._Unused);
}

static addStarts(builder:flatbuffers.Builder, startsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, startsOffset, 0);
}

static createStartsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startStartsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addEnds(builder:flatbuffers.Builder, endsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, endsOffset, 0);
}

static createEndsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startEndsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endEntityPropertySelectionEntryBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // starts
  builder.requiredField(offset, 8) // ends
  return offset;
}

static createEntityPropertySelectionEntryBuf(builder:flatbuffers.Builder, groupId:EntityPropertyGroupIdBuf, startsOffset:flatbuffers.Offset, endsOffset:flatbuffers.Offset):flatbuffers.Offset {
  EntityPropertySelectionEntryBuf.startEntityPropertySelectionEntryBuf(builder);
  EntityPropertySelectionEntryBuf.addGroupId(builder, groupId);
  EntityPropertySelectionEntryBuf.addStarts(builder, startsOffset);
  EntityPropertySelectionEntryBuf.addEnds(builder, endsOffset);
  return EntityPropertySelectionEntryBuf.endEntityPropertySelectionEntryBuf(builder);
}
}
